import { useEffect, useState, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { DataGrid } from '../../components/DataGrid.js';
import { listDesigs, type DesigRow } from '../../api/orgApi.js';

export function DesignationListPage(): ReactNode {
  const { token } = useAuth();
  const { t } = useTranslation();
  const [rows, setRows] = useState<DesigRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    listDesigs(token)
      .then(r => setRows(r.data))
      .catch(e => setError((e as Error).message))
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <main aria-label="designation-list" style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1>{t('org.designation.list.title')}</h1>
        <Link to="/org/designations/new" style={{ padding: '8px 16px', borderRadius: 6, background: 'var(--color-brand-primary)', color: 'var(--color-text-inverse)', textDecoration: 'none' }}>{t('org.designation.list.new')}</Link>
      </div>
      {error && <p role="alert" style={{ color: 'var(--color-danger)' }}>{error}</p>}
      {loading && <p>{t('common.loading')}</p>}
      {!loading && rows.length === 0 && <p>{t('org.designation.list.empty')}</p>}
      {rows.length > 0 && (
        <DataGrid<DesigRow>
          caption="designations"
          rows={rows}
          getRowId={(d) => d.desigId}
          rowTestId={(d) => `desig-${d.desigId}`}
          columns={[
            {
              key: 'code',
              header: t('org.col.code'),
              value: (d) => d.desigCode,
              render: (d) => (
                <Link to={`/org/designations/${d.desigId}/edit`} style={{ color: 'var(--color-text-link)' }}>{d.desigCode}</Link>
              ),
            },
            { key: 'name', header: t('org.col.name'), value: (d) => d.desigName },
            { key: 'level', header: t('org.col.level'), value: (d) => d.level ?? d.desigLevel ?? '—' },
          ]}
        />
      )}
    </main>
  );
}
